import React, { useEffect, useRef } from 'react'
import styled, { keyframes } from 'styled-components'
import { useAudioPlayerContext } from './AudioPlayerContext'
import Card, { Container as CardContainer } from './Card'

const Container = styled.footer`
  overflow: auto hidden;
  height: 197px;
  display: flex;
  padding-left: 30px;
  margin: 0 -30px;

  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
  }
`

const emptyLogoSrc =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMMAAADDCAMAAAAIoVWYAAAATlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////+QlxstAAAAGXRSTlMA7yCAQDC/XxDfcN6vkM+fvmERoDFQcVFPySfMjwAACZ1JREFUeNrtndmS2yAQRcUiQJhF9thx9P8/mq1Srhn5doOBjCflfsgLGUtHvdIgNL3kJS95yUte8pKXvOQzRM7Wq5zNXwlZ+YuW09cQeVF5ERuQFNRlnp5ZtA9i40UEr6dnFAfuH3LYJ7Ms581WL+Z5MCgAHsNNny86iq1FRP5sH9dmaxdjp08TZ5etjxw+i8L/NqKvTHH5rYOvTAH8oJHiX4ZaFwviTQpZKW9/iVcqm1RgermMYrwjiBDt7O6h60s04hkMSlJmtEQ29842LA2qGKwE40uvP6v0eapwGQO4OnV6qI08tP6YwXWFeuSy+q00QI23I6Mf9i2Q6YWfBklEBC0CKNQ0QpzBBAMowgCnkAskGENxkP0RRlqtfAMQowNSdF2f0WiIWewzcu/WhLqj6LnjQxJQCV1VMRJi9+PCslFstioHs/wRY7KymsVW4yD0rlsnydvXCrSahFG0BV4X4BPdLfXNUWUQUV3zlaEcBfEh8EWsAVU2vUsY4xR2EG5AjbHIDvNTY4udYu3jDzyEU6KhB0BDxB4QBkAAglaKb9sH8V3yAw1hRd9+zHFEhJ0pCG0a+zE8xMENhXBxa5PoCswpTwMh9NLeGtMFju3HQcSthygeQsgxELM0ZKMvR28vWuuL9SqQ6TtJNrOuYwpwAe0o3WuVyUs0Fa59WoA1NUPwIqj1KWkD+CvLRXThRkHUt8qcTYVOoel03Q7R0qeZ3wAEXajpzhA8Ad8E4CESdOt2CJ6Ap0gAgnCJy1gI4Xt0lRSdrw/TSAgj+3SVLF0y2+4Q7bH7G9sDOL8fnoZBiLlbP+YgydhknxIiMTPPk3jvEc8IMX10ikjam/4aEJrq0K3TP4eQs/4pkoGgJ21HQDgewukYbk8wGaUfbmAtYHAshLP3pgsBRZVTIq3pWF2+zsnYNggJt2UtWaIQSxm9qM1FBlyrFEK+PbAl4yyoNKAqvVpSO+14iIJumeIztnBEjuDvy95+KMtu01O+pxQozkgbE1VkmYZSvFYVJ0EoQlcZk9wAQzsEEyGPFGWqMSYLXKs3xOr2FkAURgoaE2eWchoHkRzdAtDYPMJEiwCmNEAT+3RNDJvyWYQmTMlb+QjEUuwTcsNWr8prJg9N6benZF0DYeJF/hm/xHRn3JMeofDD9cXusNwLDYuSZRBCzR8mz3uFzJQVrNjIQ7E7ZKBoYxEErW+pwJInUISEziKKs4OFVmbKaid+9qyoisODISZgXt5pGj+i0gKQX1UgkvWKH+93gkFBhTkQoBshMmFMwkEzV4Uubaig2w1CEgWHhniZYEiQVYEL10NEKkmcsEPEwhbNO5uDTyG1NQrMrkAFgwGriAhLWJMCPzuZjK2KTgLYJf20z2WBScNc74ioEH5PXmcKonxqeYW3cAIxkwitAtPNd/NisrIQ4iSwMUl8IVE0K/DQ6O07OoSXJYRgCzj+ThNwd/zbhhiBQwlqApt2LA2NAYzgAj7DkYBzSoI+QUQf5h74kUJSUzbVjcCxbzbPxnoF8WIRgyli8FxO2UO4iYo+sLZbId1axOBh29YygWQPochEJGEqO5B0PIN9zwDTw3w3fc5MhYYj6BUyHDsyaJw5dmUHiiEC/94nMyy72gmFweVpGbZpD6Go4nI8Q71P76tYNfVlGB+X5HuIA0KYm+PS4PxwEydL5u1T1/zwBsuYgAucBQxREnEJqYoYQmO9lKl6qUwSLiFD/T0Ukip8o56fm5BpOj5iz6rz/KH+9cK3vvMH7k75QOJE7eqxXHDJd8Z4oqhJNpfNpy2x7KJq380xD82ndZmdzqXRR+PuI3+VzZZGLA1NgTVGPvo4UbcOuVBTiwRD6xXmlNJY74nrKmbJk/rfmdCRghpKhQEjFK/DONiQH9VvDY/1vanFxggg6vveARhMRd/7gh+RIYzJCQhB026SMKUVB93v7etAm2feGllk2QZERe0V8HhobliPgz61W/ZUe4oTvx63NK3H8euihsoxs+C2W52VqFsXTRgvVKxPE9kV/+FNUryefytAXmMq2T0TsCmdyfXp0hDq6KXbWL1PINMJXOJlUf3wfg1Dp+Ncvelk0H6NKeAQqmlFuNR134yt2jdTHEKXjUz3LtQiED9/IIKuZRjcxq403AB5n6g42scDNXCbILhVy5lIx0IiLfLiuZXGA52/a4xJAUXAKlseHn1B1FBqeANjQByx+OEWviwq2N/q2FrwQOdvVgzBbAteWJP5gX3GeqPUcCRMiTcmAwDJiafMyKJERPu9GTXwpkR4riaf13JCHZIg9gAreg/ztJAVucbmzdf4/HQnnXDZotZ0e7IhajcVvjoQKeVnHoDLx+6DmRimh6F/ysx4YaArcg1q3XKvNojwpok2OQVmJ2Cq9Wi+MFIfIWQbAj+34zya7wAtH0dXYuLZ/pJfYsqoUrHkg5GHfkdiacG9G+HL1UAWRuzEU7WcikReSwI11CoigOFWp5CGf2/3DQ3z8t5crnx9KlTDyZFYn8eG96cvTDpW206WS50nFL3HvrS8tWuANREQW5Bt5yEr5gXGQ9u5Ub4IYjO6goBH8GQZxUsE8YKG2BbLXenkzVaGIEXj2T9OcBXqReDPCfAA/Dknp6X2gDhOkQFOPFGH76PIY0xwejqzpaCdHpCVzWNyJc+dCcofr1rr49HHTB7vvUp+paLLKWTfQKJtF4XMoN6SuEx2nfYyH8acg3XdGiyJaKGKnY0PO4/sLHqdR+YOAAK5dr2seiIR2s+Fm0UJxGQPfc/nO4ueh5H5DUK0Uwg1FSFsvu+Z3uI6daJIFhjIVVBhqylL3EIsolir/IBQPcqu7X7NPxbpUxmAd9TUrt2f+bATThOBwWhD3ABAo4ZNbu0QfCdDq1XcD0PB6xvA2KOA2R6A+MaaoLYqr+vhj6whKzs7fnZK9QjaIcZ/8uMUwNHYwyAW2xnhKjiEdp8YqwoZwKRiMMTybeolSoDjULpDjDIoPfL7D/wSetLtBAYcIjJCFH/GYztB+3FXfPzualGnoxn6XZqa6c7yUIw6KwG7HAPF5V4fqTx5M/47TfXzBOPPpfq8AQy3o+p9AEu2HIc85oVuNQ0XfsomTLzq0z3zOR/jbe19tBJ4VbAikslK+eMv8SrmkERVn2a88P2Y9j7NeLG9KQ7fJ1aem0IU5snnpTgMJOAp1q/oBx9lzqLNiKKePl9cgzJW/wzfn/4t0q5fG+AvRuX32J8N4D/5Lv5fmS8qJBxEs7o8zYfkGZH64lUO609Jv/7JWXk7f5W7f8lLXvKSl7zkJS/5z+QHWXmAfwZjO9oAAAAASUVORK5CYII='
const rotate = keyframes`
0% {
  transform: rotate(0)
}
100% {
  transform: rotate(360deg)
}
`
const Empty = styled.img.attrs({
  src: emptyLogoSrc,
})`
  width: 57px;
  height: 57px;
  animation: ${rotate} 3s linear infinite;
`

const Footer = () => {
  const { list, actions, current, setAudioPlaying } = useAudioPlayerContext()
  const ref = useRef()
  const { play } = actions.current()
  useEffect(() => {
    if (ref.current) {
      // @ts-ignore
      ref.current.scrollTo({
        top: 0,
        left: current * 266,
        behavior: 'smooth',
      })
    }
  }, [ref, current])

  return (
    <Container ref={ref as any}>
      {list.length ? (
        list.map((item, index) => (
          <Card
            key={item.id}
            desc={item.extract}
            type={item.source}
            onClick={() => {
              console.log('index', index)
              setAudioPlaying(false)
              play(index)
            }}
            {...item}
          />
        ))
      ) : (
        <CardContainer
          style={{
            background: '#A8E983',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            paddingBottom: '20px',
            color: '#5C9C37',
            width: 'calc(100% - 30px)',
          }}
        >
          <Empty />
          <div>正在扫描附近地点...</div>
        </CardContainer>
      )}
    </Container>
  )
}

export default Footer
